import { graphql } from "gatsby";
import React from "react";
import Layout from "../../../components/Layout";
import MemberPanel from "../../../components/MemberPanel/MemberPanel";
import RelatedServices from "../../../components/RelatedServices/RelatedServices";

const MemberPage = ({
  data: {
    member,
    member: { topics, authors, filter_types, Articles },
  },
}) => {
  const memberData = {
    photo: member?.photo?.localFile?.childImageSharp?.gatsbyImageData,
    firstname: member.firstName,
    surname: member.surname,
    jobTitle: member.jobTitle,
    category: member.catgeory,
    description: member.description,
    cta: member.cta,
  };

  return (
    <Layout
      seo={{
        title: member.metaData?.pageTitle,
        description: member.metaData?.metadescription,
        image: memberData.photo,
      }}
    >
      <MemberPanel member={memberData} />
      <RelatedServices
        topics={topics}
        authors={authors}
        tagTypes={filter_types}
        articlesData={Articles}
      />
    </Layout>
  );
};

export default MemberPage;

export const query = graphql`
  query member($slug: String!) {
    member: strapiTeamMembers(slug: { eq: $slug }) {
      topics {
        id
        type
      }
      client_types {
        id
        Type
      }
      filter_types {
        type
      }
      authors {
        id
      }
      Articles {
        articlesHeading
        insights {
          id
        }
        case_studies {
          id
        }
        press_releases {
          id
        }
        events {
          id
        }
      }
      photo {
        localFile {
          childImageSharp {
            gatsbyImageData(transformOptions: { cropFocus: NORTH })
          }
        }
        alternativeText
      }
      metaData {
        pageTitle
        metadescription
      }
      firstName
      surname
      jobTitle
      description
      catgeory
      slug
      cta {
        link
        text
      }
    }

    insights: strapiHomepage {
      insights {
        shortDesc
        image {
          image {
            alternativeText
            localFile {
              childImageSharp {
                gatsbyImageData(
                  quality: 100
                  webpOptions: { quality: 100 }
                  placeholder: TRACED_SVG
                )
              }
            }
          }
        }
      }
    }
  }
`;
